module.exports = __webpack_public_path__ + "static/img/bank_logo.a2328381.png";